import { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useOnResize } from '../../hooks/use-on-resize.js';
import { jsx } from 'react/jsx-runtime';

const Outer = /*#__PURE__*/styled.div.withConfig({
  displayName: "expander__Outer",
  componentId: "zettle__sc-yhxk5j-0"
})(["height:0px;transition:height 0.3s ease-in-out;overflow:hidden;position:relative;", ""], _ref => {
  let {
    height
  } = _ref;
  return `height: ${height}px;`;
});
const Inner = /*#__PURE__*/styled.div.withConfig({
  displayName: "expander__Inner",
  componentId: "zettle__sc-yhxk5j-1"
})(["position:absolute;width:100%;"]);
const Expander = _ref2 => {
  let {
    children,
    id
  } = _ref2;
  const refContent = useRef(null);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    refContent.current && setHeight(refContent.current.clientHeight);
  }, [children]);
  useOnResize(() => {
    refContent.current && setHeight(refContent.current.clientHeight);
  }, [children]);
  return /*#__PURE__*/jsx(Outer, {
    height: height,
    children: /*#__PURE__*/jsx(Inner, {
      id: id,
      ref: refContent,
      children: children
    })
  });
};

export { Expander };
//# sourceMappingURL=index.js.map
